<template>
  <van-cell-group>
      <van-cell title="首页"  @click="onClickHome" is-link/>
      <van-cell title="个人注册"  @click="onClickPerson" is-link/>
      <van-cell title="团队注册"  @click="onClickEnterprise" is-link/>
      <van-cell title="我的客户"  @click="onClickClient" is-link/>
      <van-cell title="我的团队"  @click="onClickTeam" is-link/>
      <van-cell title="团队审核"  @click="onClickTeamProcess" is-link/>
      <van-cell title="注册审核" @click="onClickUserProcess" is-link/>
      <van-cell title="提醒配置" @click="onClickEnterpriseProcess" is-link/>
      <van-cell title="清除缓存" @click="onClickClear" is-link/>
      <van-cell title="权限不足" @click="onClickPermission" is-link/>
      <van-cell title="登录" @click="onClickLogin" is-link/>
      <van-cell title="用户端" @click="onClickCreditHome" is-link/>
      <van-cell title="管理端" @click="onClickHome2" is-link/>
  </van-cell-group>
</template>

<script>

import user from "@/utils/user";

export default {

  data() {
    return {
     
    };
  },

  methods: {
    onClickHome() {
      this.$router.push('home');
    },
    onClickHome2() {
      this.$router.push('main');
    },
     onClickEnterprise() {
      this.$router.push('enterpriseRegister');
    },
    onClickPerson() {
      this.$router.push('personRegister');
    },
    onClickClient() {
      this.$router.push('myClient');
    },
    onClickTeam() {
      this.$router.push('myTeam');
    },
    onClickTeamProcess() {
      this.$router.push('teamProcess');
    },
    onClickUserProcess() {
      this.$router.push('registerProcess');
    },
    onClickEnterpriseProcess() {
     this.$router.push('remindConfig');
    },
    onClickClear() {
     user.cacheUserData("");
     user.clearToken();
    },
    onClickPermission() {
      this.$router.push('noPermission');
    },
    onClickLogin() {
      this.$router.push('login');
    },
    onClickCreditHome() {
      this.$router.push('credit');
    },
  }
};
</script>

<style lang="less">
.goods {
  padding-bottom: 50px;
}
</style>
